import { Component, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { PartServiceCharge } from 'app/core/model/entity-model';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-service-charge-dialog',
    templateUrl: './service-charge-dialog.component.html',
    styleUrls: ['./service-charge-dialog.component.scss'],
    standalone: false
})
export class ServiceChargeDialogComponent implements OnInit {
    result = new Subject<{ success: boolean; value?: { serviceChargeId: number; cost: number } }>();
    serviceCharges: PartServiceCharge[];
    serviceCharge: PartServiceCharge;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {
        this.serviceCharges = await this.uow.getPartServiceCharges();
    }

    async save() {
        const success = this.validate();
        if (!success) return;
        this.result.next({ success: true, value: { serviceChargeId: 1, cost: 1} });
    }

    close() {
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('serviceChargeValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('serviceChargeValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
